<div class="flex-grow-1">
  <div>
    <span class="text-wrap">{{ title() }}</span>

    @if (notification().seen === false) {
      <span class="badge text-bg-primary ms-1">{{ 'common.new' | translate }}</span>
    }

    @if (notification().important) {
      <span class="badge text-bg-warning ms-1">{{ 'common.important' | translate }}</span>
    }

    <span class="badge text-bg-info ms-1">{{ `notification.type.${notification().type}` | translate }}</span>
  </div>

  <div class="font-xs text-muted">
    <!-- Published at -->
    <span class="me-1">{{ notification().publishedAt | portalTimeAgo }}</span>

    <!-- Maintenance begin -->
    @if (notification().beginAt) {
      <span>
        {{
          'notifications.maintenance.beginAt'
            | translate: { date: notification().beginAt | portalDate: 'date-time-no-seconds' }
        }}
      </span>
    }

    <!-- Maintenance end -->
    @if (notification().endAt) {
      <span>
        {{
          'notifications.maintenance.endAt'
            | translate: { date: notification().endAt | portalDate: 'date-time-no-seconds' }
        }}
      </span>
    }
  </div>
</div>

@if (notification().seen === false) {
  <portal-icon-button
    [disabled]="busy()"
    [loading]="busyWith() === 'mark-seen:' + notification().id"
    [portalTippy]="'myNotifications.markAsSeen' | translate"
    [preventAndStop]="true"
    (onClick)="markAsSeen.emit()"
    iconClass="far fa-eye"
  ></portal-icon-button>
}

@if (canDelete() !== false) {
  <portal-icon-button
    [disabled]="busy()"
    [loading]="busyWith() === 'delete:' + notification().id"
    [portalTippy]="'myNotifications.delete' | translate"
    [preventAndStop]="true"
    (onClick)="delete.emit()"
    iconClass="far fa-trash"
    variant="danger"
  ></portal-icon-button>
}
